import { Button } from 'components/ui'
import { useOnboarding } from 'context/onboarding-context'

const Footer = () => {
  const {
    toolLibrary,
    nextStep,
    step,
    handleDeleteToolLibrary,
    previousStep,
    partFile,
    handleDeletePart,
    isCompleting,
  } = useOnboarding()

  return (
    <div className="flex flex-col-reverse pb-1 pt-4 sm:flex-row">
      <div className="flex-1 self-end pt-4 sm:self-start sm:pt-0">
        <span className="text-base font-bold text-gray-200 sm:text-lg">
          <span className="sr-only">Step</span> {step + 1} of 3
        </span>
      </div>
      {step === 0 && (
        <div className="flex flex-row gap-2 self-end">
          {(toolLibrary?.success || toolLibrary?.error) && (
            <Button
              onClick={handleDeleteToolLibrary}
              variant="large"
              light
              className="bg-transparent py-1.5 text-gray-300">
              Previous
            </Button>
          )}
          <Button
            onClick={nextStep}
            variant="large"
            primary
            className="py-1.5"
            disabled={!toolLibrary?.success}>
            Continue
          </Button>
        </div>
      )}
      {step === 2 && (
        <div className="flex flex-row gap-2 self-end">
          <Button
            onClick={() =>
              Boolean(partFile) ? handleDeletePart() : previousStep(2)
            }
            variant="large"
            light
            className="bg-transparent py-1.5 text-gray-300"
            disabled={isCompleting}>
            Previous
          </Button>
          <Button variant="large" primary className="py-1.5" disabled>
            Continue
          </Button>
        </div>
      )}
    </div>
  )
}

export default Footer
